import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWrench = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.844 8.916A6.581 6.581 0 0 1 18 1.586L14.15 5.44l1.415 1.416 3.85-3.858a6.581 6.581 0 0 1-7.328 10.16l-7.844 7.843L0 16.76l7.844-7.844zM18.69 6.894a4.581 4.581 0 0 1-7.038 3.868l-7.41 7.412-1.414-1.415 7.41-7.412a4.581 4.581 0 0 1 4.2-7.023l-1.703 1.703a2 2 0 0 0 0 2.829l1.416 1.415a2 2 0 0 0 2.828 0l1.7-1.7c.008.107.011.214.011.323z",
		fill: "currentColor"
	})
});
export default SvgWrench;
